import React, { useRef } from 'react';

import Tooltip from '@atlaskit/tooltip';

import { ExecutionStatus, Issue, TestType } from '@qality/common-model';
import { useIsOverflow } from '@qality/common-utils';

import { ExecutionStatusLozenge } from '../../atoms/ExecutionStatusLozenge';
import { IssueTestType } from '../IssueTestType';
import {
  IssueContainer,
  IssueKeyStyled,
  IssueStatusStyled,
  IssueSummaryStyled,
  IssueSummaryTextStyled,
  IssueTextStyled,
} from './TestExecutionIssue.styled';

type Props = {
  testCaseIssue: Issue;
  executionStatus: ExecutionStatus;
  testType: TestType;
};

export default function TestExecutionIssue({
  testCaseIssue,
  executionStatus,
  testType,
}: Props): JSX.Element {
  const ref = useRef();
  const { isOverflow } = useIsOverflow(ref);
  const testTypeIconStyle = {
    display: 'flex',
    alignItems: 'center',
  };
  return (
    <Tooltip
      content={isOverflow && testCaseIssue.fields.summary}
      testId='tooltip'
    >
      <IssueContainer data-testid='issue-container'>
        <IssueTestType
          testType={testType}
          customStyle={testTypeIconStyle}
          isReadOnly
          isIconOnly
          isLoading={!testType}
        />
        <IssueTextStyled>
          <IssueKeyStyled>{testCaseIssue.key}</IssueKeyStyled>
          <IssueSummaryStyled>
            <IssueSummaryTextStyled innerRef={ref}>
              {testCaseIssue.fields.summary}
            </IssueSummaryTextStyled>
          </IssueSummaryStyled>
        </IssueTextStyled>
        <IssueStatusStyled>
          <ExecutionStatusLozenge status={executionStatus} />
        </IssueStatusStyled>
      </IssueContainer>
    </Tooltip>
  );
}
